module.exports = __webpack_public_path__ + "img/Ninja_1.jpg";